import { reactive } from 'vue';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HeaderService } from '@/services/header-service.interface';
import { HeaderService as HeaderServiceImpl } from '@patsnap-utils/biz';
import { HeaderServiceProxy, HeaderServiceProxyImpl } from '@/services/header-service-proxy';

export const headerServiceModule = new ContainerModule((bind) => {
  bind(HeaderService).toConstantValue(reactive(new HeaderServiceImpl()));
  bind(HeaderServiceProxy).to(HeaderServiceProxyImpl);
});
